module.exports = __webpack_public_path__ + "media/censor-beep-1.c5d5cada.mp3";